import { ICON } from 'constants/icons';
import React, { useEffect } from 'react';
import { TextType } from '../title/Title';

type Props = {
  message: string;
  closeToastAfterSeconds: () => void;
};

const ToastPopup = (props: Props) => {
  useEffect(() => {
    props.closeToastAfterSeconds();
  }, []);

  return (
    <div
      className='px-[32px] py-5 absolute top-[80%] gap-2.5 z-50 animate-fadeIn
     left-1/2 -translate-x-1/2 bg-opacity-70 bg-black border border-gray-cc rounded flex items-center cursor-default'
    >
      <div className='w-6 h-6'>
        <img src={ICON.TOAST_COMPLETE} alt='완료' />
      </div>
      <div className={`${TextType.h4_bold} text-white`}>{props.message}</div>
    </div>
  );
};
export default ToastPopup;
